export enum ViewMediumType {
    SCREEN,
    PRINT
}
